import dayjs from 'dayjs'

export const FULL_CALENDAR_VIEW_TYPES = {
  dayView: 'timeGridDay',
  weekView: 'timeGridWeek',
  monthView: 'dayGridMonth',
}

export function getFullCalendarConvertedDateFromDayJsDate(dayJsDate) {
  return dayJsDate.format('YYYY-MM-DD')
}

export function getDayjsDateFromFullCalendarDateString(fullCalendarDateString) {
  if (!fullCalendarDateString) {
    return fullCalendarDateString
  }
  return dayjs(fullCalendarDateString)
}

export function buildNewRosterRequest(
  clinicBrandId,
  clinicLocationId,
  chamberRoomId,
  mentorId,
  currentDate,
  startTime,
  endTime,
) {
  return {
    clinicBrandId: clinicBrandId,
    clinicLocationId: clinicLocationId,
    chamberRoomId: chamberRoomId,
    mentorId: mentorId,
    customDate: currentDate,
    slotStartTime: startTime,
    slotEndTime: endTime,
  }
}

export const aumhumScheduleToFullCalendarScheduleTransformer = (scheduleData) => {
  const dayMapping = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
  };

  let workHours = [];

  scheduleData.forEach((schedule) => {
    const weeklyHourMap = schedule.weeklyHourMap;

    Object.keys(weeklyHourMap).forEach((day) => {
      const dayData = weeklyHourMap[day];

      if (dayData.available && dayData.slotList) {
        dayData.slotList.forEach((slot) => {
          workHours.push({
            daysOfWeek: [dayMapping[day]],
            startTime: slot.startTime,
            endTime: slot.endTime,
            display: "background",
            color: "#6C5190", // Light blue background
          });
        });
      }
    });
  });

  return workHours;
};